'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { MyNumberAnchorDatePage } from '../../-components/MyNumberAnchorDatePage';
export const Route = createFileRoute('/_staff/labor-core/_egov-mock/egov-onboarding/my-number-collection/anchor-date/')({
  component: MyNumberAnchorDatePage
});